module.exports = __webpack_public_path__ + "static/media/principality.ca32f2c5.jpg";